export default "__VITE_ASSET__CkTK7NPF__"